import { CSSProperties, memo, ReactNode } from 'react'
import cn from 'classnames'

import s from './Title.module.less'

interface IProps {
  children: ReactNode
  size: 'h1' | 'h2' | 'h3' | 'h4' | 'h5'
  className?: string
  color?: 'text' | 'secondary' | 'placeholder' | 'inverted' | 'blue' | 'accent' | 'disabled' | 'error'
  id?: string
  style?: CSSProperties
}

export const Title = memo(function Title({ color, className, size: Tag = 'h1', ...props }: IProps) {
  return <Tag {...props} className={cn(s.Title, s[Tag], color && s[color], className)} />
})

type TSubTitleProps = Omit<IProps, 'size'>

export const H1 = (props: TSubTitleProps) => <Title {...props} size="h1" />

export const H2 = (props: TSubTitleProps) => <Title {...props} size="h2" />

export const H3 = (props: TSubTitleProps) => <Title {...props} size="h3" />

export const H4 = (props: TSubTitleProps) => <Title {...props} size="h4" />

export const H5 = (props: TSubTitleProps) => <Title {...props} size="h5" />
